<template>
  <div class="fccMensagensTipo">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage :titlePage="titlePage"></fccTitlePage>
      <div class="row">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            addFilter
            :fields="fields"
            :status="status"
            :actions="actions"
            :items="listagemTipoMensagem"
            responsive
            :titlePage="titlePage"
          >
          </fccTable>
        </div>
      </div>
      <fccModal
        centered
        idModal="addFieldModal"
        :titleModal="titleModal"
        escondeFooter
        travaEsc
        travaBack
      >
        <form
          @submit.prevent="
            criar.mentipid === 0 ? adicionandoTipoMensagem() : editandoTipoMensagem()
          "
          autocomplete="off"
        >
          <div class="my-2">
            <div class="row">
              <div class="col-sm-12 my-2">
                <input v-model="criar.mentipid" type="hidden" />
                <fccInput extraClasses="inputLabel" v-model="criar.mentipcodigo" required
                  >Tipo de Notificação</fccInput
                >
              </div>
              <div class="col-sm-12 my-2">
                <fccInput extraClasses="inputLabel" v-model="criar.mentipdescricao" required
                  >Descrição</fccInput
                >
              </div>
              <div class="col-sm-12">
                <label>Bloqueio de Tela</label><br />
                <toggle-button v-model="criar.mentipbloqueiotela" />
              </div>
            </div>
            <div class="row my-4">
              <div class="col-sm-12 text-right">
                <fccButton classeAdd="form-control" tipo="submit">{{
                  labelsSystem.salvar
                }}</fccButton>
              </div>
            </div>
          </div>
        </form>
      </fccModal>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      titlePage: 'Tipo de Mensagens',
      listagemTipoMensagem: [],
      baseUrlNotificacao: '',
      criar: {
        mentipid: 0,
        mentipcodigo: '',
        mentipdescricao: '',
        mentipbloqueiotela: false
      },
      titleModal: '',
      actions: [
        {
          button: true,
          funcaoButton: 'editField',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteField',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      fields: [
        { key: 'mentipid', label: 'Id', sortable: true },
        { key: 'mentipcodigo', label: 'Código', sortable: true },
        { key: 'mentipdescricao', label: 'Tipo de Mensagem', sortable: true },
        { key: 'status', label: 'Bloqueio de Tela', sortable: true },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print' }
      ],
      status: [
        {
          funcaoButton: 'changeObrigatorio',
          tooltip: 'Bloqueio de Tela',
          campoStatus: 'mentipbloqueiotela',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ]
    }
  },
  methods: {
    changeObrigatorio: function (action, item) {
      this.criar = item
      this.editandoTipoMensagem()
    },
    addField: function () {
      this.criar = {
        mentipid: 0,
        mentipcodigo: '',
        mentipdescricao: '',
        mentipbloqueiotela: false
      }
      this.titleModal = 'Adicionar'
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    editField: function (action, item) {
      this.criar = item
      this.titleModal = 'Editar'
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    listandoTipoMensagens: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlNotificacao + 'MensagensTipo/Listar',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemTipoMensagem = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    editandoTipoMensagem: function () {
      this.carregaTexto(this.codeMensagem('C02'))
      axios
        .put(
          this.baseUrlNotificacao + 'MensagensTipo/Alterar',
          this.criar,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.callToast(this.mensagensUpdate.editado)
          this.listandoTipoMensagens()
          this.criar = {
            mentipid: 0,
            mentipcodigo: '',
            mentipdescricao: '',
            mentipbloqueiotela: false
          }
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.carregaTexto()
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    adicionandoTipoMensagem: function () {
      this.criar = {
        mentipcodigo: this.criar.mentipcodigo,
        mentipdescricao: this.criar.mentipdescricao,
        mentipbloqueiotela: this.criar.mentipbloqueiotela
      }
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlNotificacao + 'MensagensTipo/Adicionar',
          this.criar,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.callToast(this.mensagensUpdate.adicionado)
          this.listandoTipoMensagens()
          this.criar = {
            mentipid: 0,
            mentipcodigo: '',
            mentipdescricao: '',
            mentipbloqueiotela: false
          }
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.carregaTexto()
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    deleteField: function (action, item) {
      this.callConfirm(this.mensagemExcluir, item.mentipcodigo).then(() => {
        axios
          .delete(
            this.baseUrlNotificacao + 'MensagensTipo/Excluir/' + item.mentipid,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.listandoTipoMensagens()
            this.callToast(this.mensagensUpdate.excluido)
          })
          .catch((error) => {
            this.setErrorSystem(error)
          })
      })
    }
  },
  mounted: function () {
    this.baseUrlNotificacao = this.$fccStore.state.baseUrlNotificacao
    this.listandoTipoMensagens()
  }
}
</script>
